module.exports = __webpack_public_path__ + "static/media/dipp-text.d0163ded.svg";